import { Button } from "@/toggle-ui-kit/button";
import IconButton from "@/toggle-ui-kit/icon-button";
import { EllipsisVertical } from "lucide-react";
import { ReportMeta } from "./report-meta";
import { ReportVersion } from "./types";

interface ReportVersionRowProps {
  version: ReportVersion;
  onOpen?: () => void;
  menu?: React.ReactNode;
  /** 작성자 이름 조회 중이면 이메일 대신 스켈레톤을 보여준다. */
  isAuthorLoading?: boolean;
}

// ============================================
// ReportVersionRow
// 그룹을 펼쳤을 때 노출되는 이전 버전 행. 흰 카드, 뱃지·버전 업데이트 없음.
// 흰 카드 전체가 "이 버전 열기" 버튼이고, ⋮ 만 그 위에 올린다.
// z-[2]: 그룹 카드가 깔아둔 "최신 버전 열기" 오버레이(z-[1])보다 위여야 이 행을 눌렀을
// 때 최신 버전이 아니라 이 버전이 열린다.
// ============================================

export const ReportVersionRow = ({
  version,
  onOpen,
  menu,
  isAuthorLoading,
}: ReportVersionRowProps) => {
  return (
    <div className="relative z-[2] flex items-center gap-4 rounded-lg bg-white py-3 pl-4 pr-3">
      <button
        type="button"
        onClick={onOpen}
        aria-label={`${version.name} 열기`}
        className="absolute inset-0 z-[1] rounded-lg"
      />

      <div className="flex flex-1 min-w-0 items-center gap-8">
        <div className="flex flex-1 min-w-0 items-center gap-1">
          <span className="min-w-0 flex-1 truncate body-2-normal-medium text-label-normal">
            {version.name}
          </span>
          <ReportMeta meta={version} isAuthorLoading={isAuthorLoading} />
        </div>

        {/* 내용폭(shrink-0) 오른쪽 정렬. 서브행엔 "버전 업데이트"가 없지만,
              메인행과 ⋮ 열을 세로로 맞추기 위해 같은 버튼을 invisible로 깔아
              정확히 같은 폭을 확보한다(문구·사이즈 변경 시 자동 추종).
              배치용 상자는 pointer-events-none 이라 그 빈 자리를 눌러도 행 열기로
              통과하고, ⋮ 만 pointer-events-auto 로 되살린다. */}
        <div className="pointer-events-none relative z-10 flex shrink-0 items-center justify-end gap-3">
          <div aria-hidden className="invisible">
            <Button variant="outlined" size="base">
              버전 업데이트
            </Button>
          </div>
          <div className="pointer-events-auto">
            {menu ?? (
              <IconButton
                variant="transparent"
                icon={<EllipsisVertical className="size-4" />}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
